import { SP_LOGIN_SCRIPT_PATH } from 'src/app/constants/NextGenConstants';

export const environment = {
  production: true,
  // Path used by C&C after successful login
  loginRedirectPath: SP_LOGIN_SCRIPT_PATH,
};
